import { FC } from 'react';
import LazyLoad from 'react-lazyload';

import styles from './ProAward2023ProCard.module.scss';

interface Props {
  avatarUrl: string;
  commentMessage: string;
  jobTypeName: string;
  location: string;
  proName: string;
  profileUrl: string;
  websiteUrl: string;
}

const ProAward2023ProCard: FC<Props> = ({
  avatarUrl,
  commentMessage,
  jobTypeName,
  location,
  proName,
  profileUrl,
  websiteUrl,
}) => {
  const jobTypeIconImageUrl = '/static/images/pro-award-2023/job-type-icon.svg';

  return (
    <div className={styles['content']}>
      <div className={styles['section-job-type']}>
        <label className={styles['job-name-info']}>
          <img alt={jobTypeName} className={styles['job-type-icon']} src={jobTypeIconImageUrl} />
          {jobTypeName}
        </label>
      </div>
      <div className={styles['section-pro-info']}>
        <LazyLoad>
          <img alt={proName} className={styles.avatar} src={avatarUrl} />
        </LazyLoad>

        <div className={styles['pro-info-container']}>
          <p className={styles['pro-name']}>{proName}</p>
          <p className={styles['location-info']}>
            <img
              className={styles['location-icon']}
              src="/static/images/map-marker-black.svg"
              alt={location}
            />
            {location}
          </p>
          <p className={styles['website-info']}>
            <a href={websiteUrl} rel="noreferrer noopener" target="_blank">
              <img alt="Website" height={24} src="/static/images/internet_icon.svg" width={24} />
              <span className={styles['website-url']}>{websiteUrl}</span>
            </a>
          </p>
        </div>
      </div>
      <div className={styles['section-comment']}>
        <p className={styles['comment-title']}>受賞コメント</p>
        <pre className={styles['comment-message']}>{commentMessage}</pre>
      </div>
      <a href={profileUrl} target="_blank" rel="noreferrer">
        <div className={styles['view-profile-button']}>プロフィールを見る</div>
      </a>
    </div>
  );
};

export default ProAward2023ProCard;
